import React from 'react'

const PaymentContext = React.createContext({})

export { PaymentContext }